import { ThemeProvider } from "@/components/public/providers";
import { TailwindIndicator } from "@/components/tailwind-indicator";
import { Toaster } from "@/components/ui/sonner"
import { ViewInEnv } from "@/components/view-in-env";
import { NextIntlClientProvider } from "next-intl";
import Head from "next/head";
import { useRouter } from "next/router";
import { GeistSans } from "geist/font/sans";
import { GoogleAnalytics } from "nextjs-google-analytics";

import {
  bitter,
  cormorant,
  notoSansArabic,
  notoSerif,
  nunito,
  oswald,
  playfairDisplay,
  quattrocento,
  spaceGrotesk,
  spaceMono,
  syne,
} from "@/lib/fonts";

export default function MyApp({ Component, pageProps }: any) {
  const router = useRouter();

  return (
    <main
      className={`
      ${GeistSans.className} 
      ${cormorant.variable} 
      ${spaceMono.variable} 
      ${spaceGrotesk.variable} 
      ${notoSerif.variable} 
      ${notoSansArabic.variable}
      ${syne.variable} 

      ${nunito.variable}
      ${oswald.variable}
      ${bitter.variable}
      ${playfairDisplay.variable}
      ${quattrocento.variable}
      `}
    >

      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        storageKey="public-theme"
      >
        <Head>
          <link rel="manifest" href="/manifests/manifest-public.json" />
        </Head>

        <NextIntlClientProvider
          locale={router.locale}
          messages={pageProps.messages}
          timeZone="Europe/Vienna"
        >
          <Component {...pageProps} />
        </NextIntlClientProvider>
        <TailwindIndicator />
        <ViewInEnv />
        <Toaster />
        <GoogleAnalytics trackPageViews />
      </ThemeProvider>
      <Toaster />
    </main>
  );
}
